module.exports = __webpack_public_path__ + "img/icon-purple-clock.525cc5b2.svg";